<template>
    <v-chip style="font-size: 12px; color: grey; margin-bottom: 20px; margin-top: -5px" color="#eeeeeeee" >
        <v-avatar><v-icon color="info">info</v-icon></v-avatar>
        <span style="margin-left: -5px">{{message}}</span>
    </v-chip>
</template>

<script>
    export default {
        name: "Info",

        props: ['message'],
    }
</script>

<style scoped>

</style>